import { render, staticRenderFns } from "./ArtistDecks.vue?vue&type=template&id=57c7c53d&scoped=true"
import script from "./ArtistDecks.vue?vue&type=script&lang=ts"
export * from "./ArtistDecks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c7c53d",
  null
  
)

export default component.exports